import { useCallback } from 'react'
import { router } from 'expo-router'
import { courseContentPath } from '@utils/coursePaths'
import { useAdminPreview } from '@hooks/useAdminPreview'

interface IUseImageViewerNavigationParams {
  enrollmentId: string
  courseId: string
  courseContentsId: string
  isExtraContent?: boolean
}

export function useImageViewerNavigation({
  enrollmentId,
  courseId,
  courseContentsId,
  isExtraContent = false,
}: IUseImageViewerNavigationParams) {
  const { isPreview } = useAdminPreview()

  const handleNavigateToImageViewer = useCallback(() => {
    if (isExtraContent) {
      router.navigate(`/image_viewer`)
      return
    }

    router.navigate(
      `${courseContentPath({
        isPreview,
        enrollmentId,
        courseId,
        courseContentId: courseContentsId,
      })}/image_viewer`,
    )
  }, [courseContentsId, courseId, enrollmentId, isExtraContent, isPreview])

  return {
    handleNavigateToImageViewer,
  }
}
